document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('backToTop');

  if (!button) return;

  const toggleButton = () => {
    if (window.scrollY > 400) {
      button.classList.add('show');
    } else {
      button.classList.remove('show');
    }
  };

  toggleButton();

  window.addEventListener('scroll', toggleButton, { passive: true });

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});